<template>
  <div>
    <ul class="Fuell-Tabs">
      <li class="Fuell-Tabs--tab">
        <router-link
          to="/customers/active"
          class="Fuell-Tabs--link"
          active-class="active"
          v-t="{path:'customers_tabs_customer'}"
        >
        </router-link>

      </li>
      <li
        class="Fuell-Tabs--tab"
        v-if="!isCommercial"
      >
        <router-link
          to="/customers/users"
          class="Fuell-Tabs--link"
          active-class="active"
          v-t="{path:'customers_tabs_users'}"
        >
        </router-link>
      </li>
    </ul>
    <router-view></router-view>
  </div>
</template>

<script>

export default {
  name: 'SuperAdminUserManagement',
  computed: {
    isSuperAdmin () {
      return this.$store.getters['LoginStore/isSuperAdmin']
    },
    isImpersonatingUser () {
      return this.$store.getters['LoginStore/isImpersonating']
    },
    isCommercial () {
      return this.$store.getters['LoginStore/isCommercial']
    },
    pathByRole () {
      let path
      if (this.isSuperAdmin) {
        path = '/customers/active'
      } else {
        path = '/users/office-users/list'
      }
      return path
    }
  },
  async created () {
    await this.$store.dispatch('ConfigStore/fetchZohoPlans')
  },

  // This Checks Supplanting

  beforeRouteUpdate (to, from, next) {
    const supplanting = this.isImpersonatingUser
    if (supplanting) {
      return next({ path: this.pathByRole })
    }
    next()
  },
  // This edirects to default index based on user role
  beforeRouteEnter (to, form, next) {
    next(vm => {
      const getters = vm.$store.getters
      if (getters['LoginStore/isImpersonating']) {
        return next('/users/active')
      }
      return next('/customers/active')
    })
  }

}
</script>
